import { AppIdentifier } from "../../types";
import { ACTION_SET_USE_NEW_SDK } from "./constants";

export interface INewSdkFlagsState {
  flags: Partial<Record<AppIdentifier, boolean>>;
}

export interface INewSdkFlagsAction {
  type: string;
  appIdentifier?: AppIdentifier;
  useNewSdk?: boolean;
}

const INITIAL_STATE: INewSdkFlagsState = { flags: {} };

const newSdkFlagsReducer = (state = INITIAL_STATE, action: INewSdkFlagsAction): INewSdkFlagsState => {
  if (action.type === ACTION_SET_USE_NEW_SDK && action.appIdentifier !== undefined) {
    return { flags: { ...state.flags, [action.appIdentifier]: action.useNewSdk ?? false } };
  }
  return state;
};

export default newSdkFlagsReducer;
